import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const TrustVerification = lazy(() => import("@/pages/TrustVerification"));

export const Route = createFileRoute("/_public/trust-verification")({
  component: TrustVerification,
});
